export enum fuelType {
  ELECTRIC = 'Electric',
  PETROL = 'Petrol',
  DIESEL = 'Diesel',
  PLUG_IN_HYBRID = 'Plug-in Hybrid',
  HYBRID = 'Hybrid',
  NOT_DEFINED = 'Not defined',
  UNSPECIFIED = 'Unspecified',
}

export enum engineType {
  NOVC_HEV = 'NOVC_HEV',
}
